import { toast } from 'material-react-toastify';
import { Component } from 'react';
import statusLogo from '../assets/status.svg';
import AuthApis from '../helper/api.service';
import { postMessage } from '../utils/common.utils';
import { UserContext } from '../context/UserContext';

export default class Status extends Component {
	static contextType = UserContext;
	constructor(props) {
		super(props);
		this.state = {
			isLogout: false,
		};
		this.number = props?.location?.state?.number;
		this.userAction = props?.location?.state?.action;
		this.authApis = new AuthApis();
	}
	componentDidMount() {}
	logout = () => {
		this.authApis.logout(`${this.number}@finvu`).then((res) => {
			if (res.status === 'SUCCESS') {
				this.setState({ isLogout: true });
				postMessage('window', 'CLOSED');
				toast.success(res?.message);
				setTimeout(() => {
					this.props.history.push('/');
					window.location.reload();
				}, 1000);
			} else {
				if (res.message === 'Login Required') {
					this.props.history.push('/');
				}
				toast.error(res.message);
			}
		});
	};

	render() {
		const { consentIdList, consentIdFromLogin } = this.context;
		return (
			<section className="status-page mt-10 pb-10">
				<div className="">
					<div className="col-lg-4 offset-lg-4 col-md-8 offset-md-2 col-12">
						<div className="pt-5 mx-5">
							<img
								src={statusLogo}
								alt="status"
								className="mt-4"
								style={{ width: '75px', height: '75px' }}
							/>
							<h1
								className="fs-18 fw-700 mt-4 m-0"
								style={{
									color: this.props.customDetails.primaryColor,
									fontFamily: this.props.customDetails?.fontFamily,
								}}
							>
								Consents {this.userAction}
							</h1>
							{this.userAction === 'Resumed' ? (
								<p
									className="fs-14 fw-500 mb-4 text-center"
									style={{ color: '#6B6D6F' }}
								>
									The institution to which you gave this consent will now
									continue to receive your data
								</p>
							) : (
								<p
									className="fs-14 fw-500 mb-4 text-center"
									style={{ color: '#6B6D6F' }}
								>
									Your data will not be shared with the institution, If you
									continue to see data on your institution application, kindly
									contact them to clear the data
								</p>
							)}
							<div className="row">
								{(consentIdFromLogin ? consentIdList.length > 0 : (this.userAction !== 'Revoked' || !global.ecid)) && (
									<div className="col-12 mt-3">
										<button
											disabled={this.state.isLogout}
											type="button"
											className="btn"
											style={{
												fontFamily: this.props.customDetails?.fontFamily,
												textDecoration: 'none',
												color: this.props.customDetails?.primaryColor,
												backgroundColor: 'transparent',
												border: `1.5px solid ${this.props.customDetails?.primaryColor}`,
												borderRadius: this.props.customDetails?.borderRadius,
												padding: '8px 16px',
												fontWeight: '600',
												fontSize: '14px',
											}}
											onClick={() => {
												this.props.history.push({
													pathname: `/revoke-consent`,
													state: {
														number: this.props?.location?.state?.number,
													},
												});
											}}
										>
											MANAGE OTHER CONSENTS
										</button>
									</div>
								)}
								<div className="col-lg-6 offset-lg-3 col-md-6 offset-md-3 col-12 d-flex justify-content-center">
									<button
										disabled={this.state.isLogout}
										type="button"
										className="btn"
										style={{
											fontFamily: this.props.customDetails?.fontFamily,
											color: this.props.customDetails?.primaryColor,
											backgroundColor: 'transparent',
											border: 'none',
											textDecoration: 'underline',
											fontWeight: '600',
											fontSize: '16px',
											padding: '8px 16px',
										}}
										onClick={this.logout}
									>
										Logout
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		);
	}
}
